"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = void 0;
exports.statusOptions = [
    { value: "5reversed", label: "Canceled", color: "red" },
    { value: "8executing", label: "In Progress", color: "orange" },
    { value: "3ready", label: "Ready for Provider", color: "green" },
    { value: "4pending", label: "Pending Adjudication", color: "orange" },
    { value: "9intended", label: "Intend to Dispense", color: "purple" }
];



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-stuck-claims/optionData.ts
// module id = 3211
// module chunks = 0